import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./utils/i18n";
import * as serviceWorker from "./serviceWorker";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "mobx-react";
import { I18nextProvider } from "react-i18next";
import SimpleReactLightbox from "simple-react-lightbox";

import i18n from "./utils/i18n";
import Router from "./router";
import { loadStores } from "./utils/stores";
import UIStore from "./components/Layout/store";
import ProfileSwitcherStore from "./components/ProfileSwitcher/store";
import "./index.css";
import "moment/locale/tr";
import { ToastContainer } from "react-toastify";

const stores = {
  UIStore: new UIStore(),
  ProfileSwitcherStore: new ProfileSwitcherStore(),
  ...loadStores(),
};

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <Provider {...stores}>
      <SimpleReactLightbox>
        <BrowserRouter>
          <Router />
          <ToastContainer />
        </BrowserRouter>
      </SimpleReactLightbox>
    </Provider>
  </I18nextProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
